import React, { useState } from 'react';
import {
  Box, Typography, TableContainer, Table, TableHead, TableRow,
  TableCell, TableBody, Paper, Chip, IconButton, Tooltip,
  Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button,
} from '@mui/material';
import { Delete as DeleteIcon } from '@mui/icons-material';

const AdminUsersTable = ({ users, onDeleteUser }) => {
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);

  const handleDeleteClick = (user) => {
    setSelectedUser(user);
    setConfirmOpen(true);
  };

  const handleConfirmDelete = () => {
    if (selectedUser && onDeleteUser) {
      onDeleteUser(selectedUser.id);
    }
    setConfirmOpen(false);
    setSelectedUser(null);
  };

  return (
    <>
      <TableContainer component={Paper} sx={{ overflowX: 'auto' }}>
        <Table sx={{ minWidth: 650 }}>
          <TableHead>
            <TableRow>
              <TableCell><strong>Name</strong></TableCell>
              <TableCell><strong>Email</strong></TableCell>
              <TableCell><strong>Role</strong></TableCell>
              <TableCell><strong>Contact Info</strong></TableCell>
              <TableCell><strong>Joined</strong></TableCell>
              <TableCell align="center"><strong>Actions</strong></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {users.map((user) => (
              <TableRow key={user.id} hover>
                <TableCell>{user.first_name} {user.last_name}</TableCell>
                <TableCell>{user.email}</TableCell>
                <TableCell>
                  <Chip
                    label={user.role}
                    size="small"
                    color={user.role === 'admin' ? 'error' : user.role === 'contractor' ? 'primary' : 'secondary'}
                  />
                </TableCell>
                <TableCell>
                  {user.role === 'contractor' ? (
                    <Box>
                      {user.contractor_license_number && (
                        <Typography variant="caption" display="block">License: {user.contractor_license_number}</Typography>
                      )}
                      {user.business_address && (
                        <Typography variant="caption" display="block">Address: {user.business_address}</Typography>
                      )}
                      {user.contact_email && (
                        <Typography variant="caption" display="block">Email: {user.contact_email}</Typography>
                      )}
                      {user.contact_phone && (
                        <Typography variant="caption" display="block">Phone: {user.contact_phone}</Typography>
                      )}
                      {!user.contractor_license_number && !user.business_address && !user.contact_email && !user.contact_phone && (
                        <Typography variant="caption" color="text.secondary">No additional info</Typography>
                      )}
                    </Box>
                  ) : (
                    <Typography variant="caption" color="text.secondary">N/A</Typography>
                  )}
                </TableCell>
                <TableCell>{new Date(user.created_at).toLocaleDateString()}</TableCell>
                <TableCell align="center">
                  {user.role !== 'admin' ? (
                    <Tooltip title="Delete user">
                      <IconButton color="error" size="small" onClick={() => handleDeleteClick(user)}>
                        <DeleteIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                  ) : (
                    <Typography variant="caption" color="text.secondary">—</Typography>
                  )}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <Dialog open={confirmOpen} onClose={() => setConfirmOpen(false)}>
        <DialogTitle>Delete User</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to delete <strong>{selectedUser?.first_name} {selectedUser?.last_name}</strong> ({selectedUser?.email})?
          </DialogContentText>
          <DialogContentText sx={{ mt: 1, color: 'error.main' }}>
            {selectedUser?.role === 'contractor'
              ? 'This will also delete all projects, rooms, items, and estimates created by this contractor.'
              : 'This will remove the homeowner from any assigned projects.'}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setConfirmOpen(false)}>Cancel</Button>
          <Button onClick={handleConfirmDelete} color="error" variant="contained">Delete</Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default AdminUsersTable;
